module.exports = __webpack_public_path__ + "img/logo-new.45e5aafb.png";